import React from "react";
import { Typography, Space, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const FormularioHeader = ({ formulario, onNewField }) => {
  return (
    <Space style={{ justifyContent: "space-between", width: "100%" }}>
      <div>
        <Title level={2}>{formulario?.nombre}</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
          {formulario?.descripcion}
        </Text>
      </div>
      <Button type="primary" icon={<PlusOutlined />} onClick={onNewField}>
        Agregar Campo
      </Button>
    </Space>
  );
};

export default FormularioHeader; 